export const USER_TYPE = "&type";
export const USER_TOKEN = "&token";

const auth = {
  login(token, typeuser, callback) {
    localStorage.setItem(USER_TOKEN, token);
    if (typeuser === "admin") {
      localStorage.setItem(USER_TYPE, "tJr434-45h46-gh1i23");
    }
    if (typeuser === "client") {
      localStorage.setItem(USER_TYPE, "32asd1-5a765-i4232k");
    }
    if (typeuser === "support") {
      localStorage.setItem(USER_TYPE, "7asfg1-12as5-34sa3f");
    }
    callback();
  },
  token() {
    return {
      "Authorization": `Bearer ${localStorage.getItem(USER_TOKEN)}`,
    };
  },
  type() {
    if (localStorage.getItem(USER_TYPE) === "tJr434-45h46-gh1i23") {
      return "admin";
    }
    if (localStorage.getItem(USER_TYPE) === "32asd1-5a765-i4232k") {
      return "client";
    }
    if (localStorage.getItem(USER_TYPE) === "7asfg1-12as5-34sa3f") {
      return "support";
    }
  },
  logout(callback) {
    localStorage.clear();
    callback();
  },
};
export default auth;
